import { cn } from "@/utils/cn";

export interface CurrencyProps {
  /** Amount in the currency's major unit (rupees, not paise). */
  value: number;
  /** ISO 4217 code. BazaarX is an INR-first marketplace (ui-architecture.md's
   * search examples price everything in ₹), so that's the default rather
   * than a locale guess. */
  currency?: string;
  locale?: string;
  className?: string;
}

/**
 * Pure formatting primitive — locale-correct symbol, grouping, and no
 * decimal places for whole-rupee amounts (`Intl.NumberFormat`, not a
 * hand-rolled string template that would drift from real currency rules).
 * `Price` (ui/price.tsx) is what applies BazaarX's actual price *typography*
 * on top of this; `Currency` alone carries no font-weight/size opinion so it
 * can be reused inside contexts that already set their own (a table cell,
 * an admin KPI card).
 */
export function Currency({ value, currency = "INR", locale = "en-IN", className }: CurrencyProps) {
  const formatted = new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(value);

  return <span className={cn("tabular-nums", className)}>{formatted}</span>;
}
